// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"path":"/","layout":false,"id":"3"},"4":{"name":"index","path":"/:tab","hideInMenu":true,"parentId":"3","id":"4"},"5":{"name":"index","path":"/","parentId":"3","id":"5"},"6":{"path":"/policy","layout":false,"id":"6"},"7":{"name":"policy","path":"/policy/:tab","hideInMenu":true,"parentId":"6","id":"7"},"8":{"name":"policy","path":"/policy/","parentId":"6","id":"8"},"9":{"layout":false,"path":"/*","id":"9"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import('./EmptyRoute')),
'4': React.lazy(() => import(/* webpackChunkName: "p__home__index" */'@/pages/home/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__home__index" */'@/pages/home/index.tsx')),
'6': React.lazy(() => import('./EmptyRoute')),
'7': React.lazy(() => import(/* webpackChunkName: "p__policy__index" */'@/pages/policy/index.tsx')),
'8': React.lazy(() => import(/* webpackChunkName: "p__policy__index" */'@/pages/policy/index.tsx')),
'9': React.lazy(() => import(/* webpackChunkName: "p__utilities__404" */'@/pages/utilities/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/opt/buildhome/repo/apps/index/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
